var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallInfoSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a1 1 0 100-2 1 1 0 000 2zm1 7.455V4H0v5.455L1 12l1-2.545z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
}

export default SvgSmallInfoSymbol;